import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  ApproveIcon,
  DeleteIcon,
  EditIcon,
  EditLocationIcon,
  ExportIcon,
  MoreIcon,
} from "../../../components/common/iconography";
import { getFormTab } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const AuditCreateHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1">
        Creating a new Inventory Audit does not modify your inventory levels. To
        reconcile counts, you will need to manually edit each inventory item in
        the Reconcile Sheet tab, visible once an Audit is started.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Account: </strong> Specifies which Accounts should be
            inventoried. You can inventory the entire yard, or select a specific
            Account.
          </Typography>
        </li>
        <li>
          <Typography>
            <EditLocationIcon className={classes.icon} />
            <strong> SET ACCOUNT: </strong>
            Opens up an Inventory Map dialog, allowing you to select an Account
            and inspect locations.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Notes: </strong> Add special instructions for the Crew
            performing the Audit.
          </Typography>
        </li>
      </ul>
    </>
  );
};

export const AuditEditHelp = (props) => {
  const classes = useStyles();
  var tab = getFormTab(props);

  return (() => {
    switch (tab) {
      case "0":
        return (
          <>
            <Typography variant="subtitle1">
              <strong>Audit Status</strong>
            </Typography>
            <Typography variant="subtitle1">
              This tab allows you to follow the progress the Audit. For audits
              IN PROGRESS, as Crew visits each location, and enters product
              count, the location is highlighted to indicate work in progress,
              completed, or pending. For audits PENDING REVIEW, or COMPLETED
              this tab display a summary of audit results.
            </Typography>
            <Typography variant="subtitle1">
              You can also observe each Crew operator and their current
              location.
            </Typography>
            <ul>
              <li>
                <Typography>
                  <strong>Notes: </strong> Update notes or instructions for the
                  Crew.
                </Typography>
              </li>
              <li>
                <Typography>
                  <DeleteIcon className={classes.icon} />
                  <strong> DELETE: </strong>
                  Permanently removes unwanted Audit records. Does not affect
                  Inventory levels.
                </Typography>
              </li>
              <li>
                <Typography>
                  <ApproveIcon className={classes.icon} />
                  <strong> MARK COMPLETE: </strong>
                  Visible only for Audits that are "Pending Review". Sets record
                  status to "Completed" and clears the record from "Pending
                  Review" List.
                </Typography>
              </li>
            </ul>
          </>
        );
      case "1":
        return (
          <>
            <Typography variant="subtitle1">
              <strong>Reconcile Sheet</strong>
            </Typography>
            <Typography variant="subtitle1">
              List of Inventory items, if any, where Physical count did not
              match Quantity On Hand. Also invetnrory records with and Audit
              Note are shown here to capture possible adverse conditions. From
              the list, you can open each item to reconcile count mismatch and
              document resolution in the Inventory Notes. Items with reconciled
              counts show both the Audit counts and Reconciled Counts.
            </Typography>
            <ul>
              <li>
                <Typography>
                  <strong> Qty. On Hand: </strong>
                  Quantity expected to be present based on all prior Inventory
                  activities.
                </Typography>
              </li>
              <li>
                <Typography>
                  <strong> Qty. Physical: </strong>
                  Physical quantity count of inventoried product.
                </Typography>
              </li>
              <li>
                <Typography>
                  <strong> Reco. On Hand: </strong>
                  Adjusted / reconciled quantity On Hand.
                </Typography>
              </li>
              <li>
                <Typography>
                  <strong> Reco. Physical: </strong>
                  Adjusted / reconciled Physical quantity.
                </Typography>
              </li>
              <li>
                <Typography>
                  <strong> Notes: </strong>
                  <MoreIcon className={classes.icon} /> Open the record to
                  inspect latest Audit notes.
                </Typography>
              </li>
              <li>
                <Typography>
                  <EditIcon className={classes.icon} />
                  <strong> EDIT: </strong>
                  Opens up corresponding Inventory record. Update either Qty. On
                  Hand, or Qty. Physical to bring caunts to match. You can see
                  all prior inventory activity in the right-hand sidebar, the
                  Notes Tab or, the History Tab. Remember to document resolution
                  in the Notes tab. Saving the record, will bring you back to
                  this page.
                </Typography>
              </li>
            </ul>
          </>
        );
      case "2":
        return (
          <>
            <Typography variant="subtitle1">
              <strong>Audit Rport</strong>
            </Typography>
            <Typography variant="subtitle1">
              Summary of all Inventory items, listed by Lot Number, or Product
              Code. Quantity On Hand and Physical counts are displayed either
              for each inventrory item, or are tallied up by Product Code. The
              roport show quantities as reconciled.
            </Typography>
            <ul>
              <li>
                <Typography>
                  <strong> Group By: </strong>
                  Select report format. Switch between listing by Lot Number, or
                  grouping by Product Code.
                </Typography>
              </li>
              <li>
                <Typography>
                  <ExportIcon className={classes.icon} />
                  <strong> EXPORT: </strong>
                  Each roport format can be exported independently into Excel
                  using the EXPORT button.
                </Typography>
              </li>
            </ul>
          </>
        );
      default:
        return <></>;
    }
  })();
};
